import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function RequireAuth({ children, requireCompany = false }) {
  const {
    isAuthenticated,
    selectedCompanyId,
    companiesLoading,
    companiesInitialized,
    requiresRegistration,
    user,
  } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is authenticated but account doesn't exist in DB, redirect to register
  if (requiresRegistration) {
    return <Navigate to="/registrer" state={{ from: location, needsAccount: true }} replace />;
  }

  const needsCompany = requireCompany && !user?.isAdmin;
  if (needsCompany) {
    if (!companiesInitialized || companiesLoading) {
      return (
        <div className="auth-layout">
          <div className="auth-card">
            <header className="auth-header">
              <span className="auth-badge">KI Chat</span>
              <h1>Laster konto…</h1>
              <p>Vent et øyeblikk mens vi henter selskapene dine.</p>
            </header>
          </div>
        </div>
      );
    }

    if (
      !selectedCompanyId
      && !location.pathname.startsWith('/companies')
    ) {
      return <Navigate to="/companies" state={{ from: location }} replace />;
    }
  }

  return children;
}

export default RequireAuth;
